<!-- Skip to Content Tab -->
<nav id="skip-to-main-content" attr.aria-label="{{ 'SKIP.SKIP_TO_MAIN' | translate }}">
  <h2 tabindex="0" hidden>{{ 'SKIP.SKIP_LINKS' | translate }}</h2>
  <ul>
    <li>
      <button
        mat-button
        type="button"
        appSendAnalytics
        attr.aria-label="{{ 'SKIP.SKIP_TO_MAIN' | translate }}"
        id="skip-to-main-content-button"
        (click)="skip()">
        {{ 'SKIP.SKIP_TO_MAIN' | translate }}
      </button>
    </li>
  </ul>
</nav>
